import { localeCompareNumericLowercase, type Locale } from '@ardoq/locale';
import { type ContextSort } from '@ardoq/common-helpers';
import { compareComponentIds } from './compareComponentIds';
import { DependencyMapReference } from './types';
import type { EnhancedScopeData } from '@ardoq/data-model';
import type { ArdoqId } from '@ardoq/api-types';

const getAlternateReferenceComparator =
  (
    referenceTypeNames: Map<string, string>,
    sort: ContextSort,
    locale: Locale,
    scopeData: EnhancedScopeData,
    workspaceIds: ArdoqId[]
  ) =>
  (
    {
      referenceTypeId: referenceTypeIdA,
      node: { modelId: componentIdA },
    }: DependencyMapReference,
    {
      referenceTypeId: referenceTypeIdB,
      node: { modelId: componentIdB },
    }: DependencyMapReference
  ) =>
    compareComponentIds(
      componentIdA,
      componentIdB,
      sort,
      locale,
      scopeData,
      workspaceIds
    ) ||
    (referenceTypeIdA &&
      referenceTypeIdB &&
      localeCompareNumericLowercase(
        referenceTypeNames.get(referenceTypeIdA) ?? '',
        referenceTypeNames.get(referenceTypeIdB) ?? '',
        locale
      )) ||
    0;
export { getAlternateReferenceComparator };
